// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M8 1.75C11.45 1.75 14.25 4.44 14.25 7.75C14.25 11.06 11.45 13.75 8 13.75C7.44 13.75 6.96 13.62 6.5 13.67C5.25 13.81 4 14.25 2.55 13.86C2.14 13.75 2.1 13.49 2.45 13.25C3.16 12.77 3.53 12.12 3.14 11.64C2.25 10.61 1.75 9.26 1.75 7.75C1.75 4.44 4.55 1.75 8 1.75Z',
];
